import useOurRollbarLog from './useOurRollbarLog';

const useOurLog = () => {
  const { log } = useOurRollbarLog();

  return { log };
};

export default useOurLog;
